import { type FC } from "react";
import { type ProductData } from "../../../../../../../models/ProductData";
import PreviewTableMaterialIdInput from "../../../../../../../BulkATCPopup/components/PreviewTable/PreviewTableMaterialIdInput";
import { useBooleanState } from "../../../../../../../common/hooks/useBooleanState";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { C_PRIMARY } from "~/common/components/icon/Colors";

interface Props {
  value: string;
  isPreferred?: boolean;
  onChange: (product: ProductData) => void;
  disabled?: boolean;
}

const useStyles = makeStyles({
  inputRoot: {
    paddingLeft: "23px !important",
  },
});

export const WishlistMaterialIdInput: FC<Props> = (props) => {
  const { t } = useTranslation();

  const { val: isFocused, setTrue: setFocused, setFalse: setUnfocused } = useBooleanState(false);

  const classes = useStyles();

  const isPreferred = props.isPreferred;

  return (
    <div className={"p-relative"}>
      <PreviewTableMaterialIdInput
        label={t("wishlistPage.table.header.designation")}
        classes={!isFocused && isPreferred ? classes : undefined}
        onFocus={setFocused}
        onBlur={setUnfocused}
        helperText={" "}
        startAdornment={isPreferred && !isFocused && <Icon type={IconType.Star} style={{ color: C_PRIMARY }} />}
        {...props}
      />
    </div>
  );
};
export default WishlistMaterialIdInput;
